<template>
  <div>
    <label>
      {{ index }}.
      {{ question }}
    </label>
    <b-link v-if="questionPlan" class="d-flex mb-3" @click="showModal">
      <i class="material-icons align-self-center small mx-1">
        flag
      </i>
      Click to see your plan
    </b-link>
    <b-form-input
      v-model="inputData"
      placeholder="Enter your answer"
      :required="required"
      @input="handleChangeElement({ id, value: inputData })"
    ></b-form-input>
    <modal :Gid="id" :planAnswers="getRelatedPlanAnswers" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import mixinListenerChangeElement from '@/mixins/listenerChangeElement';
import modal from '@/components/practice/modalQuestionPlan.vue';

export default {
  components: {
    modal,
  },
  mixins: [mixinListenerChangeElement],
  props: {
    question: String,
    index: Number,
    id: Number,
    answers: Array,
    questionPlan: Number,
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('planning', ['getRelatedPlanAnswers']),
    ...mapGetters('user', ['getUserId']),
  },
  data() {
    return {
      inputData: null,
    };
  },
  methods: {
    ...mapActions('planning', ['FetchRelatedPlanAnswers']),
    showModal() {
      this.FetchRelatedPlanAnswers({
        parent: this.getUserId,
        questions: [this.questionPlan],
      }).then((response) => {
        this.modalQuestion = true;
        console.log('Response', response);
      });
    },
  },
  mounted() {
    if (this.answers != null && this.answers.length != 0) {
      this.answers.forEach((element) => {
        this.inputData = element.answer_text_1;
      });
    }
  },
};
</script>
